import logo from './logo.svg';
import './App.css';
import GatewayCount from './Pages/gatewayCount'
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<GatewayCount />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
